export default [
  { id: 1, value: 'Advertisement' },
  { id: 2, value: 'Google' },
  { id: 3, value: 'From a friend' },
  { id: 4, value: 'Other' }
]
